<template>
  <div class="main">
    <div class="bg-img-all">
      <img
        src="../../static/mobile/btn.png"
        alt=""
        class="download-button-sty"
      />
    </div>
  </div>
</template>

<script>
import { chnup } from "../utils/tools";
export default {
  data() {
    return {};
  },
  methods: {
    download_apk: function (event) {
      chnup("be_download");
    },
  },
  created() {},
  mounted() {
    chnup("be_load");
    this.$nextTick(() => {
      chnup("bg_loaded");
    });
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  height: 100vh;
  width: 100vw;
}
.bg-img-all {
  display: inline-block;
  width: 100vw;
  height: 179.42vw;
  background-image: url("../../static/mobile/bg.png");
  background-size: cover;
  position: relative;
}
.down-small {
  position: absolute;
  top: 4.54vw;
  left: 60.46vw;
  width: 36.67vw;
  height: 12.69vw;
}
.download-button-sty {
  position: absolute;
  top: 19.72vw;
  left: 7.41vw;
  width: 87.78vw;
  height: 19.63vw;
  animation-name: scaleDraw;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-duration: 1s;
}
@keyframes scaleDraw {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.03);
  }
  50% {
    transform: scale(1.03);
  }
  75% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landingpage.vue